
import React, { useEffect, useState } from 'react'
import MySegmented from '../../../components/segmented/Segmented'
import TableWithSkeleton from '../../../components/table/TableWithSkeleton'
import { Spin } from 'antd';
import { GetMTFCloseTradesByLoginIdApi, GetMTFOpenTradesByLoginIdApi } from '../../../api/request/lp/lpdashboard';
import lpCloseTradeColumns from '../../../columns/lp/lpCloseTradeColumns';
import lpOpenTradeColumns from '../../../columns/lp/lpOpenTradeColumns';


function LpTrades({ loginId }) {
    const [tab, setTab] = useState('open');
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const options = [
        { label: 'Open Trades', value: 'open' },
        { label: 'Closed Trades', value: 'closed' },
    ];

    const fetchTrades = async (type, loginId) => {
        if (!loginId) return setData([]);

        setIsLoading(true);

        try {
            const response = type === 'open'
                ? await GetMTFOpenTradesByLoginIdApi(loginId)
                : await GetMTFCloseTradesByLoginIdApi(loginId);

            const payload = response?.data;
            let items = [];
            if (Array.isArray(payload)) items = payload;
            else if (Array.isArray(payload?.data)) items = payload.data;
            else if (Array.isArray(payload?.data?.data)) items = payload.data.data;
            else items = payload?.data || payload || [];

            const normalized = items.map(item => ({ ...item, close: item.close || null }));
            setData(normalized);
        } catch (error) {
            console.error('Error fetching trades:', error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (loginId) {
            fetchTrades(tab, loginId);
        }
    }, [tab, loginId]);

    return (
        <div className=" border-2 border-light rounded-[10px] p-5">
                <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold">{tab === 'open' ? 'Open Trades' : 'Closed Trades'}</h3>
                    <div>
                        <MySegmented options={options} value={tab} setValue={setTab} style={{ minWidth: 220 }} />
                    </div>
                </div>
                <div className="mt-4">
                    {isLoading ? (
                        <div className="flex justify-center py-10">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <TableWithSkeleton columns={tab === 'open' ? lpOpenTradeColumns() : lpCloseTradeColumns()} data={data} loading={false} />
                    )}
                </div>
            </div>
    )
}

export default LpTrades
